module.exports = __webpack_public_path__ + "static/media/coffee-togo.dc5fa84f.svg";